import { createSelector } from 'reselect';

import { initialState } from './reducer';

const selectBDOSettingDomain = state => state.bdoSettings || initialState;

const makeSelectBDOSetting = () =>
  createSelector(selectBDOSettingDomain, substate => substate.bdoSetting);

const makeSelectBDOSettingParams = () =>
  createSelector(selectBDOSettingDomain, substate => substate.params);

export { selectBDOSettingDomain, makeSelectBDOSetting, makeSelectBDOSettingParams };
